// Research in Assistant specific enumerations
// Keep this file focused on RIA domain to avoid bloating the central events schema.

export enum RiaTab {
  States = 'states',
  Federal = 'federal',
}

export enum RiaJurisdictionType {
  State = 'state',
  Federal = 'federal',
}

export enum RiaToggleState {
  On = 'on',
  Off = 'off',
}

export enum RiaDisableReason {
  UserToggle = 'user_toggle',
  SourcesCleared = 'sources_cleared',
}

export enum RiaDialogSource {
  KnowledgeSourcesDropdown = 'knowledge_sources_dropdown',
  LegalResearch = 'legal_research',
}

export enum RiaToggleName {
  LegalResearch = 'legal_research',
}

export enum RiaSourceTriggerLocation {
  InlineReference = 'inline_reference',
  // Wire value kept for analytics continuity: badges reported as 'footnote_popover'
  // since the popover era.
  CitationBadge = 'footnote_popover',
  ViewerHeaderButton = 'viewer_header_button',
  ContentViewerHeader = 'content_viewer_header',
  ReferencesListItem = 'references_list_item',
  ReferencesHighlight = 'references_highlight',
  StandaloneViewerHeader = 'standalone_viewer_header',
  CitatorControl = 'citator_control',
}

export enum RiaViewerTab {
  SourceView = 'source_view',
  Citator = 'citator',
}

export enum RiaCitatorSection {
  ImportantCases = 'important_cases',
  CaseCitations = 'case_citations',
  CitingCases = 'citing_cases',
  RelatedCases = 'related_cases',
}
